import prevalorTechnology from '#app/assets/images/logos/100prevalor-technology.svg'
import logoAsociacionValorTres from '#app/assets/images/logos/asociacion-valor-tres-color-logo.svg'
import logoDesarrolloSustentableValorTres from '#app/assets/images/logos/valor-tres-sustentable-color-logo.svg'
import { cn } from '#app/utils/misc.tsx'
import { Tag } from './ui/tag.tsx'

interface TeamSectionProps {
	className?: string
}

export function TeamSection({ className }: TeamSectionProps) {
	return (
		<section className={cn('bg-white py-8 md:py-16', className)}>
			<div className="container mx-auto px-6 md:px-16">
				<div className="mx-auto flex max-w-[300px] flex-col items-center justify-between gap-8 md:max-w-[1200px] md:flex-row md:gap-0">
					{/* Team Info */}
					<div className="flex w-full flex-col items-center justify-center gap-8 md:inline-flex md:w-96 md:items-start">
						{/* Tag/Chip */}
						<Tag
							size="l"
							corner="rounded"
							variant="secondary"
							color="green"
							appearance="solid"
							leftIcon="user-multiple"
							option="text-icon-left"
						>
							Unidad de negocios
						</Tag>

						{/* Main Heading */}
						<h2 className="font-parkinsans text-center text-2xl leading-8 font-medium text-blue-800 md:justify-center md:self-stretch md:text-left md:text-4xl md:leading-[56px]">
							Nuestro equipo
						</h2>
					</div>

					{/* Team Images */}
					<div className="grid grid-cols-2 items-center gap-10 md:flex md:flex-wrap md:items-center md:justify-end md:gap-16">
						{/* Team Image 1 - Left aligned */}
						<div className="flex justify-start">
							<div className="w-[120px] overflow-hidden md:w-[150px]">
								<img
									src={logoAsociacionValorTres}
									alt="Asociación Valor Tres"
									className="h-full w-full object-cover"
								/>
							</div>
						</div>

						{/* Team Image 2 - Right aligned */}
						<div className="flex justify-end">
							<div className="w-[120px] overflow-hidden md:w-[150px]">
								<img
									src={logoDesarrolloSustentableValorTres}
									alt="Desarrollo Sustentable Valor Tres"
									className="h-full w-full object-cover"
								/>
							</div>
						</div>

						{/* Team Image 3 - Left aligned */}
						<div className="flex justify-start">
							<div className="w-[120px] overflow-hidden md:w-[150px]">
								<img
									src="/resources/images?src=%2Fimg%2Ftria.png&w=150&h=84&format=webp"
									alt="TRIA Revolution"
									className="h-full w-full object-cover"
								/>
							</div>
						</div>

						{/* Team Image Overlay with Logo and Technology Chip - Right aligned */}
						<div className="flex justify-end md:mt-0 md:items-end">
							<div className="w-[120px] overflow-hidden md:w-[150px]">
								<img
									src={prevalorTechnology}
									alt="100prevalor Technology"
									className="h-full w-full object-contain"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}

export default TeamSection
